import React from 'react';
import { useDispatch } from 'react-redux';
import { dimensionDrilldown } from '@store/overviewDashboard/base/actions';
import { EllipsisTooltip } from '@components/common';
import { StyledEllipsis } from './styled';

function Cell({ cellData, column, rowData }) {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(dimensionDrilldown(column.key, rowData));
  };

  return (
    <StyledEllipsis onClick={handleClick}>
      <EllipsisTooltip text={cellData} />
    </StyledEllipsis>
  );
}

export default Cell;
